// extracted by mini-css-extract-plugin
export default {"root":"UserLayout_root__+jAkm","container":"UserLayout_container__7OP5H","siteContent":"UserLayout_siteContent__4+5HN","main":"UserLayout_main__F9Bww"};